import React, { forwardRef } from "react";
import SubNav from "../";
import IBuildrProps from "../../../utilities/IBuildrProps";

export interface IPathNavProps extends IBuildrProps {
    rootPath: string;
    children;
}

const PathNav = forwardRef((props: IPathNavProps, ref: any) => {
    const { children, rootPath } = props;

    return (
        <div ref={ref} data-id={props.cmsId} className={props.editorClassObj}>
            <SubNav>
                {
                    React.Children.map(children, (child) => {
                        return React.cloneElement(child, {
                            ...child.props,
                            selected: child.props.selected,
                            url: `${rootPath}/${child.props.url}`
                        });
                    })
                }
            </SubNav>
        </div>
    );
});

export default PathNav;